import { NoAccessRedirect, useIsOnboardingRoute, useSession } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";

export function ProtectAccessBoundary({ children }: PropsWithChildren) {
    const { products } = useSession();
    const isOnboardingRoute = useIsOnboardingRoute();

    if (products?.protect.hasAccess === false && !isOnboardingRoute) {
        return <NoAccessRedirect />;
    }

    return children;
}
